<template>
  <header class="t-relative">
    <div :class="['c-header', { '-responsive': isResponsive }]">
      <div class="o-container t-full t-fill">
        <div class="o-grid -xs-middle t-full">
          <div class="o-grid__item -xs-10 t-lg-hide">
            <div class="c-header__slot">
              <vResponsiveCategoryMenu :category-tree="categoryTree" />
            </div>
          </div>

          <div class="o-grid__item -xs-4 -lg-shrink t-text-center">
            <a
              href="/"
              aria-label="ir para a página inicial"
            >
              <div class="o-logo">
                <vIcon
                  name="logo"
                  size="medium"
                />
              </div>
            </a>
          </div>

          <div
            class="o-grid__item -xs-24 -xs-last -lg-initial-order -lg-grow"
            :class="{ 't-xs-hide t-lg-block': !shouldShowMobileSearch }"
          >
            <vSearch
              :initial-context="initialSearchContext"
              :placeholder-complements="placeholderComplements"
              :should-auto-focus-on-desktop="shouldAutoFocusOnDesktop"
            />
          </div>

          <div class="o-grid__item -xs-10 -lg-shrink t-text-right">
            <vNavigation
              :departments="departments"
              :opened-panel-index="openedPanelIndex"
              @open-panel="setNavigationPanel"
            />
          </div>
        </div>
      </div>
    </div>

    <vNavigationPanel
      v-if="isLargeDesktop"
      :category-tree="categoryTree"
      :columns="departments"
      :opened-panel-index="openedPanelIndex"
      @mouse-leave-content="setNavigationPanel(null)"
      @mouse-enter-content="onMouseEnterContent"
    />

    <vSearchHighlightsPanel
      v-if="isLargeDesktop"
      :initial-context="initialSearchContext"
    />
  </header>
</template>

<script>
  import vIcon from '@/web/components/icon.vue'
  import vNavigation from '@/web/components/header/navigation.vue'
  import vSearch from '@/web/components/header/search.vue'
  import vResponsiveCategoryMenu from '@/web/components/header/responsive-category-menu.vue'
  import vNavigationPanel from '@/web/components/header/navigation/navigation-panel.vue'
  import vSearchHighlightsPanel from '@/web/components/header-search/search-highlights-panel.vue'

  import media from '@/tools/mixins/media'

  import '@engines/stylesheets/ui/objects/_grid.scss'
  import '@engines/stylesheets/ui/objects/_container.scss'
  import '@engines/stylesheets/ui/objects/_logo.scss'

  export default {
    name: 'VHeader',
    components: {
      vNavigation,
      vSearch,
      vResponsiveCategoryMenu,
      vIcon,
      vNavigationPanel,
      vSearchHighlightsPanel
    },
    mixins: [media],
    props: {
      categoryTree: {
        type: Array,
        required: true
      },
      departments: {
        type: Array,
        required: true
      },
      shouldShowMobileSearch: {
        type: Boolean,
        default: true
      },
      placeholderComplements: {
        type: Array,
        required: true
      },
      shouldAutoFocusOnDesktop: {
        type: Boolean,
        default: false
      },
      isResponsive: {
        type: Boolean,
        default: true
      },
      initialSearchContext: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        openedPanelIndex: null
      }
    },
    methods: {
      setNavigationPanel(index) {
        clearTimeout(this.delayedAction)
        this.delayedAction = setTimeout(() => {
          this.openedPanelIndex = index
        }, 200)
      },
      onMouseEnterContent() {
        clearTimeout(this.delayedAction)
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .o-icon.-xs-size-medium.-logo {
    font-size: 30px;
  }
</style>
